import { InputOTP, InputOTPGroup, InputOTPSlot } from "./ui/input-otp";

export const OtpField = ({ value, onChange, testId = "otp-input-code", onComplete }) => (
  <InputOTP maxLength={6} value={value} onChange={onChange} onComplete={onComplete} data-testid={testId} inputMode="numeric" pattern="^[0-9]*$">
    <InputOTPGroup className="gap-2">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <InputOTPSlot
          key={i}
          index={i}
          className="h-12 w-11 rounded-lg border border-slate-700 bg-[#05070e] font-mono text-lg text-emerald-300 first:rounded-lg last:rounded-lg"
        />
      ))}
    </InputOTPGroup>
  </InputOTP>
);
